import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import SimpleSteps, { useSteps } from "../../components/SimpleSteps";
import { steps } from "../../utils/util";
import { useTheme } from '@mui/material/styles';
import { portalCfg } from "../../config";
import { DoneOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function OrderCompleteView(props) {
    const stepsControl = useSteps(steps);
    const { palette, spacing } = useTheme();
    const { t } = useTranslation();
    return (
        <Grid item xs={12}>
            {/* <Grid xs={12} item container justifyContent="center">
                <SimpleSteps
                    steps={steps}
                    step={stepsControl.step}
                    nextStep={stepsControl.nextStep}
                    prevStep={stepsControl.prevStep}
                    goToStep={stepsControl.goToStep}
                />
            </Grid> */}
            <Grid item xs={12} bgcolor={palette.common.white} borderRadius={spacing(3)} padding={2}>
                <Grid item container xs={12} justifyContent={'center'}>
                    <img src={`${portalCfg.publicPath}/images/birthday.jpg`} height={250}/>
                </Grid>
                <Typography variant="h4" color={palette.primary.main} textAlign={'center'} fontWeight={'bold'}>{t('order_successfully')}</Typography>
                <Grid item xs={12} py={2} px={4}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" fontWeight={'bold'}>{t('here_what_happens_next')}</Typography>
                    </Grid>
                    <Stack direction={'row'} spacing={1} alignItems={'center'}>
                        <DoneOutlined style={{ color: palette.success.main, fontSize: '30px' }} />
                        <Typography variant="subtitle1">{t('reviewing_your_order')}</Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={1} alignItems={'center'}>
                        <DoneOutlined style={{ color: palette.success.main, fontSize: '30px' }} />
                        <Typography variant="subtitle1">{t('receive_confirmation_via_email')}</Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={1} alignItems={'center'}>
                        <DoneOutlined style={{ color: palette.success.main, fontSize: '30px' }} />
                        <Typography variant="subtitle1">{t('get_details_soon')}</Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Grid>
    )
}
